// Build-time configuration, read from Vite's import.meta.env (see .env.example).
// Values are baked into the bundle at build time.

function readEnv(key: keyof ImportMetaEnv): string {
  const raw = import.meta.env[key];
  return typeof raw === "string" ? raw.trim() : "";
}

/** REST API base, no trailing slash. */
export const API_BASE = readEnv("VITE_API_BASE").replace(/\/+$/, "");

/** API-Gateway key, sent as `x-api-key` on every request. */
export const API_KEY = readEnv("VITE_API_KEY");

/** Cognito user pool id (auth). Region is inferred from its `<region>_xxx` prefix. */
export const COGNITO_USER_POOL_ID = readEnv("VITE_COGNITO_USER_POOL_ID");

/** Cognito app client id (this site's public SPA client). */
export const COGNITO_CLIENT_ID = readEnv("VITE_COGNITO_CLIENT_ID");

/** Public image base URL, WITH a single trailing slash. */
export const IMAGE_BASE_URL = (() => {
  const v = readEnv("VITE_IMAGE_BASE_URL");
  if (!v) return "";
  return v.endsWith("/") ? v : v + "/";
})();

/** Public URL for an S3 image key (e.g. "<ulid>/original.jpg"). */
export function imageUrl(key: string | undefined | null): string | undefined {
  if (!key) return undefined;
  return IMAGE_BASE_URL + key;
}

/** True when all required build-time vars are present. */
export const CONFIG_OK = Boolean(
  API_BASE && API_KEY && IMAGE_BASE_URL && COGNITO_USER_POOL_ID && COGNITO_CLIENT_ID,
);

/** Human-readable list of any missing config keys, for a startup warning. */
export function missingConfig(): string[] {
  const missing: string[] = [];
  if (!API_BASE) missing.push("VITE_API_BASE");
  if (!API_KEY) missing.push("VITE_API_KEY");
  if (!IMAGE_BASE_URL) missing.push("VITE_IMAGE_BASE_URL");
  if (!COGNITO_USER_POOL_ID) missing.push("VITE_COGNITO_USER_POOL_ID");
  if (!COGNITO_CLIENT_ID) missing.push("VITE_COGNITO_CLIENT_ID");
  return missing;
}
